<template>
  <v-select
      hide-details
      dense
      outlined
      label="Airport"
      :items="items"
      v-model="airport"
      :multiple="false">
  </v-select>
</template>

<script>

export default {
  name: 'AirportSelect',
  props: {
    value: {
      type: String,
      required: false,
      default: 'RIX'
    },
    items: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: () => ({
    menu: false,
  }),
  components: {
  },
  methods: {
  },
  watch: {
    items (val) {
      console.log(val)
      if(val && !val.includes(this.airport)) {
        this.airport = 'RIX'
      }
    }
  },
  computed: {
    airport: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  }
}
</script>
